import { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import ContainerMini from "@components/containerMini";
import * as Types from '../../../types';
import useUserData from "@hooks/useUserData";
import { toast } from "sonner";

import Logo from '@assets/images/logoMini.svg';
import TinyMceEditor from "../blog/editor";

export default function AdmTicketView() {
  let { id } = useParams();
  const { userData } = useUserData();
  const [ticket, setTicket] = useState<Types.Ticket | null>();
  const [updated, setUpdated] = useState<boolean>(true);
  const [message, setMessage] = useState('');
  const [iMessage, setIMessage] = useState('');

  useEffect(() => {
    if (updated === false) return;
    axios.get(`${import.meta.env.VITE_API_ADM_URL}/ticket/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }})
    .then(response  => {
      setTicket(response.data);
      setIMessage(response.data.msg);
      setUpdated(false);
    })
    .catch(_ => {
      setTicket(null);
    });
  }, [updated]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append('msg', message);
    formData.append('userId', ticket?.userId || 'null');

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/ticket/${ticket?.id}/send`, formData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }})
      .then(async (response) => {
        setUpdated(true);
        toast.success('Сообщение отправлено');
      });
  };

  const handleUpdateSubmit = async (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append('uuid', id ?? '');
    formData.append('msg', iMessage);
    
    axios.post(`${import.meta.env.VITE_API_ADM_URL}/ticket/${ticket?.id}`, formData, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('authToken')
    }})
    .then(async (response) => {
      setUpdated(true);
      toast.success('Информация обновлена');
    });
  };

  function convertToDate(isoDate: any) {
    const date = new Date(isoDate);
    const options: any = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Intl.DateTimeFormat('ru-Ru', options).format(date);
  }

  return (
    <MainContent>    
      <SEO 
        title="Обращение"
        description="Магазин"
        ogUrl="https://artcons.io/"
      />

      <div className={css.headTicket}>
        <Link to={`/admin/tickets`} className={css.back}><i className="fi fi-rr-arrow-small-left"></i> Вернуться</Link>
        <h1>
          <div><a className={css.type}>{ticket?.type === 0 && "Вопрос"} {ticket?.type === 1 && "Проблема"} {ticket?.type === 2 && "Квоты"}</a> {ticket?.topic}</div>
          {ticket?.status === 0 && <a className={css.status} style={{ background: "#0f4dca40" }}><i className="fi fi-rr-time-oclock"></i> На рассмотрении</a>}
          {ticket?.status === 1 && <a className={css.status} style={{ background: "#cab40f40" }}><i className="fi fi-rr-envelope"></i> Есть ответ</a>}
          {ticket?.status === 2 && <a className={css.status} style={{ background: "#33b07454" }}><i className="fi fi-rr-check-circle"></i> Решили</a>}
        </h1>
        <div dangerouslySetInnerHTML={{ __html: ticket?.msg! }}></div>
      </div>

      <div className={css.flex}>
        <div className={css.col1}>
          <div className={css.msgs}>
            {ticket?.msgs.map(item => (
              <div className={css.msg}>
                {item.to === 'user' ?
                  <img alt="avatar" src={Logo}/>
                :
                  <img alt="avatar" src="https://avatars.mds.yandex.net/i?id=e3583305ecf833845bce0d64157b63b5_l-5220445-images-thumbs&n=13" />
                }

                <div className={css.text}>
                  <b>{item.to === 'user' ? "Поддержка" : "Пользователь"} <a className={css.date}>{convertToDate(item.createdAt)}</a></b>
                  <p dangerouslySetInnerHTML={{ __html: item?.msg! }}></p>
                </div>
              </div>
            ))}
          </div>
          
          <form className={css.form} onSubmit={handleSubmit}>
            <TinyMceEditor initialValue={message} editorChange={setMessage} type={1} />
            <button type="submit" style={{ width: "100%", background: "#0f51d4", marginTop: 10, padding: 10, color: "#fff" }}>Отправить сообщение</button>
          </form>
        </div>

        <div className={css.col2}>
          <form className={css.form} onSubmit={handleUpdateSubmit}>
            <a style={{ color: "#000" }} href={`/admin/user/${ticket?.userId}`}>Пользователь: {ticket?.userId || "Нет Id пользователя"}</a>

            <div className={css.inputBlock} style={{ marginBottom: 10 }}>
              <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Тип</label>
              <select name="type" defaultValue={ticket?.type}>
                  <option value={0} selected={ticket?.type === 0}>Вопрос</option>
                  <option value={1} selected={ticket?.type === 1}>Проблема</option>
                  <option value={2} selected={ticket?.type === 2}>Квоты</option>
              </select>
            </div>

            <div className={css.inputBlock} style={{ marginBottom: 10 }}>
              <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Тема обращения</label>
              <input placeholder="Тема обращения" name="topic" defaultValue={ticket?.topic} />
            </div>

            <div className={css.inputBlock} style={{ marginBottom: 10 }}>
              <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Первоначальное сообщение</label>
              {/* <textarea placeholder="Первоначальное сообщение" name="msg" defaultValue={ticket?.msg} /> */}
              <TinyMceEditor initialValue={iMessage} editorChange={setIMessage} type={1} />
            </div>

            <div className={css.inputBlock} style={{ marginBottom: 10 }}>
              <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Статус обращения</label>
              <select name="status" defaultValue={ticket?.status}>
                <option value={0} selected={ticket?.status === 0}>На рассмотрении</option>
                <option value={1} selected={ticket?.status === 1}>Есть ответ</option>
                <option value={2} selected={ticket?.status === 2}>Решили</option>
              </select>
            </div>

            <div className={css.inputBlock} style={{ marginBottom: 10 }}>
              <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Комментарий администратора</label>
              <textarea placeholder="Комментарий администратора" name="adminComment" defaultValue={ticket?.adminComment} />
            </div>
                
            <button type="submit" style={{ width: "100%", background: "#0f51d4", marginTop: 10, padding: 10, color: "#fff" }}>Обновить информацию</button>
          </form>
        </div>
      </div>
    </MainContent>
  )
}